// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"18":"results","784":"stats","908":"history"}[chunkId] + "." + {"18":"6bbde887","784":"556d9ed9","908":"d7708c31"}[chunkId] + ".css";
};